<template>
  <!-- 弹窗-新建升级规则 -->
  <y-dialog
    :title="dialogTitle"
    :visible="visible"
    width="1000px"
    :before-close="cancelBtn"
    @close="cancelBtn"
  >
    <div class="rule-wrap">
      <!-- 左侧：可选指标 -->
      <div class="rule-left">
        <div
          class="indicator-group"
          v-for="group in indicatorGroups"
          :key="group.key"
        >
          <div class="group-title">{{ group.title }}</div>
          <div class="group-body">
            <span
              class="indicator-item"
              :class="{ disabled: isSelected(item.key) }"
              v-for="item in group.items"
              :key="item.key"
              @click="addCondition(item)"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </div>

      <!-- 右侧：已选条件 -->
      <div class="rule-right">
        <div class="right-title">已选条件</div>
        <y-tip class="right-tip"> 多个标签之间是且的关系 </y-tip>
        <div class="cond-list">
          <div
            class="cond-item"
            v-for="(cond, index) in conditions"
            :key="cond.key"
          >
            <div class="cond-label">
              <span class="required">*</span>{{ cond.label
              }}{{ cond.type === "amount" ? "满" : "" }}：
            </div>
            <div class="cond-control">
              <!-- 累计交易金额（实付）：支持两位小数 -->
              <template v-if="cond.type === 'amount'">
                <el-input
                  v-model="cond.value"
                  class="cond-input"
                  placeholder="请输入内容"
                  @input="handleAmountInput(cond)"
                  @blur="handleNumBlur(cond)"
                ></el-input>
                <span class="unit">{{ cond.unit }}</span>
              </template>

              <!-- 累计交易次数 -->
              <template v-else-if="cond.type === 'count'">
                <el-input
                  v-model="cond.value"
                  v-numZOnly
                  class="cond-input"
                  placeholder="请输入内容"
                  @blur="handleNumBlur(cond)"
                ></el-input>
                <span class="unit">{{ cond.unit }}</span>
              </template>

              <!-- 购买过商品 -->
              <template v-else-if="cond.type === 'goods'">
                <el-select
                  v-model="cond.op"
                  class="cond-select"
                  style="width: 100px"
                >
                  <el-option label="包含" value="1"></el-option>
                  <el-option label="不包含" value="2"></el-option>
                </el-select>
                <span class="goods-link" @click="openGoods(index)"
                  >已选择 {{ (cond.items || []).length }} 个商品</span
                >
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                <!-- content插槽 -->
                  <template #content>
                    <div>包含特定商品：特定商品的订单才会纳入计算范围。</div>
                    <div>排除特定商品：除特定商品外，其他商品的订单均纳入计算范围。若订单内含排除商品，则该笔订单排除不算入。</div>
                  </template>
                  <img
                    src="@/assets/new-image/header/quest.svg"
                    class="quest-icon"
                    alt
                  />
                </el-tooltip>
              </template>

              <!-- 积分类 -->
              <template v-else-if="cond.type === 'point'">
                <el-select
                  v-model="cond.op"
                  class="cond-select"
                  style="width: 100px"
                >
                  <el-option
                    v-for="opt in pointOpList"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="cond.value"
                  v-numZOnly
                  class="cond-input"
                  style="margin-left: 8px"
                  placeholder="请输入内容"
                  @blur="handleNumBlur(cond)"
                ></el-input>
              </template>

              <!-- 当前等级 -->
              <template v-else-if="cond.type === 'level'">
                <el-select
                  v-model="cond.op"
                  class="cond-select"
                  style="width: 100px"
                >
                  <el-option label="属于" value="include"></el-option>
                  <!-- <el-option label="不属于" value="notIn"></el-option> -->
                </el-select>
                <el-select
                  v-model="cond.cardValue"
                  class="cond-select"
                  style="width: 100px; margin-left: 8px"
                >
                  <el-option
                    v-for="card in cardOptions"
                    :key="card.value"
                    :label="card.label"
                    :value="card.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="cond.levelValue"
                  class="cond-select"
                  style="width: 100px; margin-left: 8px"
                >
                  <el-option
                    v-for="level in levelOptions"
                    :key="level.value"
                    :label="level.label"
                    :value="level.value"
                  ></el-option>
                </el-select>
              </template>
            </div>
            <i
              class="el-icon-remove cond-del"
              @click="removeCondition(index)"
            ></i>
          </div>
          <div class="cond-empty" v-if="conditions.length === 0">
            请在左侧选择需要设置的指标
          </div>
        </div>
      </div>
    </div>
    <!-- 选择商品组件 -->
    <select-goods
      v-if="goodsState"
      @transferName="goodsPopupBtn"
      :postForm="goodsPostForm"
      :skuIsShow="false"
      :scoresCardId="$store.state.MemberSystemInfo.scoresCardId"
    ></select-goods>

    <template slot="footer">
      <y-button type="blue" @click="saveBtn">保存</y-button>
      <y-button @click="cancelBtn">取消</y-button>
    </template>
  </y-dialog>
</template>

<script>
import selectGoods from "@/components/select-goods.vue";
export default {
  components: { selectGoods },
  props: {
    title: {
      type: String,
      default: "升级规则",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    // 当前操作的等级行（保存时回传给父组件）
    row: {
      type: Object,
      default: () => ({}),
    },
    // 等级可选值（父组件的等级列表）
    gradeList: {
      type: Array,
      default: () => [],
    },
    // 编辑时传入的规则下标（null 表示新建）
    ruleIndex: {
      type: Number,
      default: null,
    },
    // 编辑时传入的规则数据
    rule: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      // 左侧指标分组
      indicatorGroups: [
        {
          key: "order",
          title: "订单指标",
          items: [
            {
              key: "totalAmount",
              label: "累计交易金额（实付）",
              type: "amount",
              unit: "元",
            },
            {
              key: "totalCount",
              label: "累计交易次数",
              type: "count",
              unit: "次",
            },
          ],
        },
        {
          key: "goods",
          title: "商品指标",
          items: [{ key: "buyGoods", label: "购买过商品", type: "goods" }],
        },
        {
          key: "member",
          title: "会员指标",
          items: [
            { key: "totalPoint", label: "累计获取积分", type: "point" },
            { key: "validPoint", label: "当前有效积分", type: "point" },
            { key: "consumePoint", label: "累计消费积分", type: "point" },
            { key: "currentLevel", label: "当前等级", type: "level" },
          ],
        },
      ],
      // 已选条件
      conditions: [],
      pointOpList: [
        { label: "大于", value: ">" },
        { label: "大于等于", value: ">=" },
        { label: "小于", value: "<" },
        { label: "小于等于", value: "<=" },
        { label: "等于", value: "=" },
        { label: "不等于", value: "!=" },
      ],
      // 会员卡：当前会员体系只有一张卡
      cardOptions: [{ label: "会员卡", value: "card" }],
      // 数值输入范围
      minNum: 1,
      maxNum: 999999,
      // 商品选择弹窗
      goodsState: false,
      goodsIndex: -1,
      goodsPostForm: [],
    };
  },
  computed: {
    dialogTitle() {
      return this.ruleIndex === null ? `新建${this.title}` : `编辑${this.title}`;
    },
    levelOptions() {
      return (this.gradeList || []).map((item) => ({
        label: item.gradeName,
        value: item.gradeCode,
      }));
    },
  },
  mounted() {
    // 编辑：回显已有条件
    if (this.rule && Array.isArray(this.rule.conditions)) {
      this.conditions = JSON.parse(JSON.stringify(this.rule.conditions));
    }
  },
  methods: {
    isSelected(key) {
      return this.conditions.some((item) => item.key === key);
    },
    // 点击左侧指标：加入已选条件
    addCondition(item) {
      if (this.isSelected(item.key)) return;
      this.conditions.push({
        ...item,
        op:
          item.type === "goods"
            ? "1"
            : item.type === "level"
            ? "include"
            : ">",
        value: "",
        items: [],
        cardValue: this.cardOptions[0] && this.cardOptions[0].value,
        levelValue: this.levelOptions[0] && this.levelOptions[0].value,
      });
    },
    removeCondition(index) {
      this.conditions.splice(index, 1);
    },
    // 数值是否在 1 ~ 999999 之间
    inNumRange(val) {
      const num = Number(val);
      return num >= this.minNum && num <= this.maxNum;
    },
    // 金额输入：只保留数字和小数点，最多两位小数
    handleAmountInput(cond) {
      let val = String(
        cond.value === null || cond.value === undefined ? "" : cond.value
      ).replace(/[^\d.]/g, "");
      const [intPart, ...decimalParts] = val.split(".");
      cond.value = decimalParts.length
        ? `${intPart || "0"}.${decimalParts.join("").slice(0, 2)}`
        : intPart;
    },
    // 数值输入失焦：金额保留两位小数，超出范围自动纠正
    handleNumBlur(cond) {
      if (
        cond.value === "" ||
        cond.value === null ||
        cond.value === undefined
      ) {
        return;
      }
      let num = Number(cond.value);
      if (isNaN(num)) {
        cond.value = "";
        return;
      }
      // 金额最多两位小数
      if (cond.type === "amount") {
        num = Number(num.toFixed(2));
      }
      if (num < this.minNum) {
        cond.value = this.minNum;
        this.$message.warning("数值范围为1-999999");
      } else if (num > this.maxNum) {
        cond.value = this.maxNum;
        this.$message.warning("数值范围为1-999999");
      } else if (cond.type === "amount") {
        // 去掉多余的前导 0 和末尾多余的 0
        cond.value = num;
      }
    },
    // 选择商品
    openGoods(index) {
      this.goodsIndex = index;
      this.goodsPostForm = this.conditions[index].items || [];
      this.goodsState = true;
    },
    goodsPopupBtn(list, state) {
      this.goodsState = false;
      if (state == 1) {
        this.conditions[this.goodsIndex].items = list || [];
      }
    },
    // 保存前校验：每个条件都要填完整
    saveBtn() {
      if (!this.conditions.length) {
        this.$message.warning("请选择需要设置的指标");
        return;
      }
      for (const cond of this.conditions) {
        if (cond.type === "goods") {
          if (!(cond.items || []).length) {
            this.$message.warning(`请选择${cond.label}对应的商品`);
            return;
          }
        } else if (cond.type === "level") {
          if (!cond.cardValue || !cond.levelValue) {
            this.$message.warning(`请选择${cond.label}`);
            return;
          }
        } else if (!cond.value) {
          this.$message.warning(`请填写${cond.label}`);
          return;
        } else if (!this.inNumRange(cond.value)) {
          this.$message.warning("数值范围为1-999999");
          return;
        }
      }
      // 保留商品完整信息，编辑时选择器才能回显
      const rules = this.conditions.map((cond) => ({
        key: cond.key,
        label: cond.label || "",
        type: cond.type,
        op: cond.op,
        value: cond.value || "",
        unit: cond.unit || "",
        items: cond.items || [],
        cardValue: cond.cardValue || "",
        levelValue: cond.levelValue || "",
      }));
      // TODO: 升级规则保存接口就绪后替换成实际请求
      this.$emit("save", { row: this.row, rules, ruleIndex: this.ruleIndex });
      this.cancelBtn();
    },
    cancelBtn() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.rule-wrap {
  display: flex;
  height: 480px;
}

// 左侧指标
.rule-left {
  width: 310px;
  flex-shrink: 0;
  overflow-y: auto;
  padding-right: 16px;
}

.indicator-group {
  margin-bottom: 16px;

  .group-title {
    height: 38px;
    line-height: 38px;
    padding: 0 12px;
    background: #f5f6f7;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .group-body {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    min-height: 96px;
    padding: 12px;
    border: 1px solid #ebeef5;
    border-top: none;
  }

  .indicator-item {
    height: 26px;
    line-height: 24px;
    padding: 0 10px;
    margin: 0 8px 8px 0;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    font-size: 13px;
    color: #606266;
    cursor: pointer;

    &:hover {
      color: $theme-color;
      border-color: $theme-color;
    }

    // 已加到右侧的指标置灰
    &.disabled {
      color: #c0c4cc;
      border-color: #ebeef5;
      background: #fafafa;
      cursor: not-allowed;
    }
  }
}

// 右侧已选条件
.rule-right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #ebeef5;

  .right-title {
    height: 38px;
    line-height: 38px;
    padding: 0 16px;
    background: #f2f2f2;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .right-tip {
    margin: 4px;
  }

  .cond-list {
    flex: 1;
    overflow-y: auto;
  }

  .cond-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
  }

  .cond-label {
    width: 190px;
    flex-shrink: 0;
    padding-right: 8px;
    box-sizing: border-box;
    text-align: right;
    font-size: 13px;
    color: #606266;

    .required {
      color: #f56c6c;
      margin-right: 2px;
    }
  }

  .cond-control {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .cond-input {
    width: 160px;
  }

  .unit {
    margin-left: 8px;
    font-size: 13px;
    color: #606266;
  }

  .goods-link {
    margin-left: 8px;
    font-size: 13px;
    color: $theme-color;
    cursor: pointer;
  }

  .quest-icon {
    width: 14px;
    height: 14px;
    margin-left: 4px;
    cursor: pointer;
  }

  .cond-del {
    flex-shrink: 0;
    margin-left: 8px;
    font-size: 18px;
    color: #409eff;
    cursor: pointer;
  }

  .cond-empty {
    padding: 24px 0;
    text-align: center;
    font-size: 13px;
    color: #c0c4cc;
  }
}
</style>